import { mount } from 'svelte';
import './styles.css';
import App from './App.svelte';

const target = document.getElementById('app');
if (!target) throw new Error('#app root missing');

const app = mount(App, { target });

export default app;
